

import React, { Component } from 'react';

import './App.css';
import data from './data.json';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import ImageView from './ImageView.js';
import AdminController from './AdminController.js';
import axios from 'axios';


import firebase from './fire.js';



// const urlParams = new URLSearchParams(window.location.search);
// const queryId = urlParams.get('id');

// let projectId = (queryId!==null) ? queryId : "projektID1";
let projectId = "projektID1";
this.users = data.users;
this.projects = data.projects;
this.data = data.projects[projectId];



class App extends Component {
  constructor(props){
    super(props);

    this.firebaseRef = firebase.database();

    this.state = {
      // data:data.projects[projectId],
      loading:true,
      projects: data.projects,
      viewBox:'0 0 0 0',
      clickedHouseId:false
      // viewBox:"0 0 " + img.width + " "  + img.height
    };

    this.handleHouseClick = this.handleHouseClick.bind(this);
    this.updateState = this.updateState.bind(this);
    this.updateSpecificParentState = this.updateSpecificParentState.bind(this);

    this.ipAddress = this.getIpAddress();

  }


  getIpAddress(){

    const ip = axios.get(
      "https://us-central1-nordtag-275e6.cloudfunctions.net/getIp",
      {headers: { 'Content-Type': 'application/json' } }
    ).then(function(response){
      // return Promise.resolve(response.data);
      this.setState({
        ip:response.data
      })
      return response.data;

    }.bind(this))

    return ip
    // ip.then(function(val){
    //   return val
    // })
  }

  componentWillUpdate(props, state){

    if(state.data && state.viewBox === '0 0 0 0' && !state.activeImgId){
      this.img = state.data.project.images["image1"];
      var img = new Image();
      img.src = this.img;

      let _activeImgId = Object.keys(state.data.project.images)[0];


      let count = 0;
      var checkForImgSize = setInterval(function(){
        count++;

        if(img.width > 0 || count >10){
          clearInterval(checkForImgSize);

          this.setState({
            viewBox:"0 0 " + img.width + " "  + img.height,
            activeImgId: _activeImgId
          });
        }
      }.bind(this),300);

    }
  }

  componentDidUpdate(props, state){

    if(state.loading && state.data){

      setTimeout(function () {
        this.setState({
          loading:false
        })
      }.bind(this), 100);

    }

  }

  componentDidMount() {
    var _projects = [];
    this.firebaseRef.ref('projects').on('value', function(snap){
      _projects = snap.val();

        if(window.location.pathname === "/admin" || !this.state.data){
          // console.log('uppdaterar');
          this.setState({
            data: _projects[projectId],
            projects: _projects
          });
        }



    }.bind(this));

    var _users = [];

    this.firebaseRef.ref('users').on('value', function(snap){
      _users = snap.val();

      this.setState({
        users: _users
      })

    }.bind(this));

  }



  handleHouseClick(id, ip){
    ip = ip.split('.').join('-');

    let newData = this.state.data.items[id];
    if(newData.users){
      let clickInfo = newData.users[ip] || {clicks:0};
      clickInfo.clicks++;

      newData.users[ip] = clickInfo;
    }
    else {
      let clickInfo = {clicks:1};
      newData.users = {};
      newData.users[ip] = clickInfo;

    }

    // alert('projects/' + projectId  + '/items/' + id + " - - - - " + ip);

    this.firebaseRef.ref('projects/' + projectId  + '/items/' + id).set(newData);

  }


  updateState(_data, _activeImgId){
    this.setState({
      data: _data,
      activeImgId: _activeImgId
    })
  }
  updateSpecificParentState(_data){
    this.setState( _data );
  }

  render(){

    const Admin = () => (
      <div className="app admin">
        <AdminController
          projectId={projectId}
          viewBox={this.state.viewBox}
          users={this.state.users}
          data={this.state.data}
          projects={this.state.projects}
          updateSpecificParentState={this.updateSpecificParentState}
          activeObjectId={this.state.activeObjectId}
          activeImgId={this.state.activeImgId} />
      </div>
    );

    const Home = () => (
      <div className="view">
        <ImageView
          currentIp={this.state.ip}
          viewBox={this.state.viewBox}
          data={this.state.data}
          updateParentState={this.updateState}
          handleHouseClick={this.handleHouseClick}
          clickedId={this.state.clickedHouseId}
          activeImgId={this.state.activeImgId} />
      </div>
    );

    if(!this.state.data || !this.state.users){
      return (
        <div className="flex-col container">
          <div className="loading"></div>
        </div>
      );
    }
    else {


      return(
        <Router>

          <div className="app">
            <Route exact path="/" component={Home}  />
            <Route path="/admin" component={Admin}  />
            <div className={ (this.state.loading) ? 'loading' : 'loading loaded'}></div>
          </div>

        </Router>
      );
    }
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js